import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from '@americanexpress/dls-react';
import Image from './Image';

const DetailTemplate = (props) => {
  const {
    item,
    imgProps,
    assetDimension,
    cardCount,
    setFormSubmissionPayload,
    formSubmissionPayload,
    setSelectedCards,
    selectedCards,
    showProductInfo,
    minimumSelections,
    invalidHandler,
    fieldValidation,
    selectedCardCount,
    setSelectedCardCount,
  } = props;
  // Keys
  const cardId = `selectedCardNum-${cardCount}`;
  const cardHolderName = `selectedEmbossedName-${cardCount}`;
  const cardToken = `selectedAccountToken-${cardCount}`;
  const isCardSelected = formSubmissionPayload[cardId] === item.identifiers.displayAccountNumber;
  useEffect(() => {
    const selectedCount = Object.keys(formSubmissionPayload).filter((key) => key.startsWith('selectedCardNum-')
    ).length;
    setSelectedCardCount(selectedCount);
  }, [isCardSelected]);
  const handleCardSelection = () => {
    if (isCardSelected) {
      // Remove from payload and selectedCards
      const updatedPayload = { ...formSubmissionPayload };
      delete updatedPayload[cardId];
      delete updatedPayload[cardHolderName];
      delete updatedPayload[cardToken];
      setFormSubmissionPayload({ ...updatedPayload, elemId: null });
      const updatedSelectedCards = { ...selectedCards };
      delete updatedSelectedCards[cardId];
      delete updatedSelectedCards[cardHolderName];
      setSelectedCards(updatedSelectedCards);
    } else {
      // Add to payload and selectedCards
      setFormSubmissionPayload({
        ...formSubmissionPayload,
        [cardId]: item.identifiers.displayAccountNumber,
        [cardHolderName]: item.holder.profile.embossedName,
        [cardToken]: item.accountToken,
        elemId: null,
      });
      setSelectedCards({
        ...selectedCards,
        [cardId]: item.identifiers.displayAccountNumber,
        [cardHolderName]: item.holder.profile.embossedName,
      });
    }
  };
  return (
    <div style={{ paddingTop: '10px' }}>
      <Image
        imgProps={imgProps}
        assetDimension={assetDimension}
        memberInfo={item.product}
        dataObject={{ formSubmissionPayload }}
      />
      <div style={{ paddingTop: '10px' }}>
        <Checkbox
          id={`${cardCount}`}
          name={`${cardCount}`}
          style={{ marginRight: '10px' }}
          label={item.identifiers.displayAccountNumber}
          onChange={handleCardSelection}
          checked={isCardSelected}
          value={isCardSelected}
          required={
            fieldValidation.required
            && selectedCardCount < minimumSelections
          }
          onInvalid={invalidHandler}
        />
        {showProductInfo && (
          <>
            <p style={{ marginLeft: '32px' }}>
              {item.product.digitalInfo.productDesc}
            </p>
            <p style={{ marginLeft: '32px' }}>{item.holder.profile.fullName}</p>
          </>
        )}
      </div>
    </div>
  );
};

DetailTemplate.propTypes = {
  imgProps: PropTypes.objectOf(PropTypes.shape),
  assetDimension: PropTypes.string,
  item: PropTypes.objectOf(PropTypes.shape),
  cardCount: PropTypes.number,
  setFormSubmissionPayload: PropTypes.func,
  formSubmissionPayload: PropTypes.objectOf(PropTypes.shape),
  setSelectedCards: PropTypes.func,
  selectedCards: PropTypes.objectOf(PropTypes.shape),
  showProductInfo: PropTypes.bool,
  minimumSelections: PropTypes.number,
  invalidHandler: PropTypes.func,
  fieldValidation: PropTypes.objectOf(PropTypes.shape),
  selectedCardCount: PropTypes.number,
  setSelectedCardCount: PropTypes.func,
};

export default DetailTemplate;
